<mat-form-field appearance="outline" class="w-100">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    multiple
    [placeholder]="placeholder"
    [formControl]="control"
    [compareWith]="provider.compareWith"
    (openedChange)="openedChange($event)"
  >
    <div class="box-search" id="select-input">
      <mat-checkbox #checkAll class="box-select-all" (change)="toggleSelectAll($event)"></mat-checkbox>
      <input #searchInput type="text" (input)="filterItem(searchInput.value)" [placeholder]="placeholder" />
    </div>
    <mat-select-trigger>
      {{ onDisplayString() }}
    </mat-select-trigger>
    <mat-option
      #matOption
      *ngFor="let option of filteredOptions"
      (click)="onSelectionChange(matOption)"
      [value]="option"
      [disabled]="disableSelection"
      >{{ provider.description(option) }}
    </mat-option>
  </mat-select>
  <mat-icon *ngIf="error()" matSuffix class="mat-error">error</mat-icon>
  <mat-hint>{{ hint }}</mat-hint>
  <mat-error *ngIf="error()">{{ error() }}</mat-error>
</mat-form-field>
